export default "__VITE_ASSET__DYu0$p8D__"